import { ROUTE_NAME } from '@constants';
const clubIntroduction = {
  path: '/club-introduction',
  redirect: '/club-introduction/introduction',
  meta: {
    breadcrumb: true,
    breadcrumbName: '클럽소개',
  },
  name: ROUTE_NAME.ClubIntroduction,
  children: [
    {
      name: ROUTE_NAME.ClubIntroduction,
      path: 'introduction',
      component: () => import('@views/club-introduction/Introduction.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '클럽소개',
      },
    },
    {
      name: ROUTE_NAME.ResortIntro,
      path: 'resort-intro',
      component: () => import('@views/club-introduction/ResortIntro.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '리조트소개',
      },
    },
    {
      name: ROUTE_NAME.GolfTelIntro,
      path: 'golf-tel-intro',
      component: () => import('@views/club-introduction/GolfTelIntro.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '골프텔소개',
      },
    },
    {
      name: ROUTE_NAME.CourseInformation,
      path: 'information',
      component: () => import('@views/club-introduction/CourseInformation.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '코스소개',
      },
    },
    {
      name: ROUTE_NAME.Location,
      path: 'location',
      component: () => import('@views/club-introduction/Location.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '오시는길',
      },
    },
    {
      name: ROUTE_NAME.RealCam,
      path: '/real-cam',
      component: () => import('@views/club-introduction/RealCam.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '실시간 현장',
      },
    },
    {
      name: ROUTE_NAME.Lobby,
      path: 'lobby',
      component: () => import('@views/club-introduction/Lobby.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '현관, 로비',
      },
    },
    {
      name: ROUTE_NAME.Restaurant,
      path: 'restaurant',
      component: () => import('@views/club-introduction/Restaurant.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '대식당',
      },
    },
    {
      name: ROUTE_NAME.HalfwayHouse,
      path: 'halfway-house',
      component: () => import('@views/club-introduction/HalfwayHouse.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '스타트하우스',
      },
    },
    {
      name: ROUTE_NAME.BanquetHall,
      path: 'banquet-hall',
      component: () => import('@views/club-introduction/BanquetHall.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '연회장',
      },
    },
    {
      name: ROUTE_NAME.LockerRoom,
      path: 'locker',
      component: () => import('@views/club-introduction/LockerRoom.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '락커룸, 사우나',
      },
    },
    {
      name: ROUTE_NAME.GasStation,
      path: 'gas-station',
      component: () => import('@views/club-introduction/GasStation.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '주요소, 편의점',
      },
    },
    {
      name: ROUTE_NAME.ClubHouse,
      path: 'clubhouse',
      component: () => import('@infra/views/club-introduction/ClubHouse.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '클럽하우스',
      },
    },
    {
      name: ROUTE_NAME.DrivingRange,
      path: 'driving-range',
      component: () =>
        import('@infra/views/club-introduction/DrivingRange.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '드라이빙레인지',
      },
    },
    {
      name: ROUTE_NAME.StartHouse,
      path: 'start-house',
      component: () => import('@infra/views/club-introduction/StartHouse.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '스타트하우스',
      },
    },
    {
      name: ROUTE_NAME.BBQ,
      path: 'bbq',
      component: () => import('@infra/views/club-introduction/BBQ.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '빌라가든 BBQ',
      },
    },
    {
      name: ROUTE_NAME.GroupRoom,
      path: 'group-room',
      component: () => import('@infra/views/club-introduction/GroupRoom.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '단체실',
      },
    },
    {
      name: ROUTE_NAME.ProShop,
      path: 'pro-shop',
      component: () => import('@infra/views/club-introduction/ProShop.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '프로샵',
      },
    },
    {
      name: ROUTE_NAME.PuttingPractice,
      path: 'putting-practice',
      component: () =>
        import('@infra/views/club-introduction/PuttingPractice.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '퍼팅연습',
      },
    },
  ],
};

export default clubIntroduction;
